import React from 'react';
import { useTranslation } from 'react-i18next';
import GettingHereTemplate from '../../components/GettingHere/GettingHereTemplate';

const GettingHereAtacama: React.FC = () => {
  const { t } = useTranslation();
  
  const atacamaProps = {
    variant: 'atacama' as const,
    heroTitle: t('properties/atacama:gettingHere.hero.title'),
    heroDescription: t('properties/atacama:gettingHere.hero.description'),
    heroImage: '/assets/figma/b511fc05b56f6f56ab808fe346dacf0108ddd079.png',
    locationInfo: {
      title: t('properties/atacama:gettingHere.location.title'),
      address: t('properties/atacama:gettingHere.location.address.description'),
      directions: [
        {
          title: t('properties/atacama:gettingHere.location.fromSantiago.title'),
          description: t('properties/atacama:gettingHere.location.fromSantiago.description')
        }
      ],
      nearbyBorders: [
        { country: 'Bolivia', border: 'Hito Cajón', distance: '45 km' },
        { country: 'Argentina', border: 'Paso de Jama', distance: '155 km' }
      ]
    },
    transferInfo: t('properties/atacama:gettingHere.location.nearbyBorders.description')
  };

  return <GettingHereTemplate {...atacamaProps} />;
};

export default GettingHereAtacama;